import "./DoctoriceInstitutionalWebsite.module.css";
import Header from "@/reusable_sections/Header";
import AutomotiveMainHighlight from "./sections/AutomotiveMainHighlight";
import CatalogoDeProdutos from "./sections/CatalogoDeProdutos";
import RelatedProducts from "./sections/RelatedProducts";
import TheoryFoundations from "./sections/TheoryFoundations";
import EconomicIntermediateAdvancedBuilds from "./sections/EconomicIntermediateAdvancedBuilds";
import BlogEInsights from "./sections/BlogEInsights";
import InformationAndVideo from "./sections/InformationAndVideo";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function DoctoriceInstitutionalWebsitePage() {
  return <div>
      <Header />
      <AutomotiveMainHighlight />
      <CatalogoDeProdutos />
      <RelatedProducts />
      <TheoryFoundations />
      <EconomicIntermediateAdvancedBuilds />
      <BlogEInsights />
      <InformationAndVideo />
      <Contact />
      <Footer />
    </div>;
}